import { SendActionReturnFailure, SendActionType } from './ActionAnalyticsClient';
import { ActionPayload } from './actions/actionTypes';

export class ActionStorage {
    private readonly ACTION_REQUESTS_STORAGE_IDENTIFIER = 'SERP_FAILED_ACTION_REQUESTS' as const;

    /**
     * Saves unfinished request to local storage.
     */
    public saveRequest(payload: ActionPayload) {
        const savedRequests = this.getSavedRequests();
        savedRequests.push(payload);
        localStorage.setItem(this.ACTION_REQUESTS_STORAGE_IDENTIFIER, JSON.stringify(savedRequests));
    }

    /**
     * Sends all unfinished requests from local storage.
     * Removes them from local storage if they were sent successfully.
     * Otherwise, they will be sent again on next page load.
     */
    public async sendSavedRequests(sendCallback: SendActionType) {
        const requests = this.getSavedRequests();
        this.clearSavedRequests();

        const responses = requests.map((request) => sendCallback(request));
        const settledResponses = await Promise.all(responses);
        settledResponses.forEach((response) => {
            if (!response.delivered) {
                this.saveRequest(response.action);
            }
        });
    }

    /**
     * Gets unfinished requests from local storage.
     */
    private getSavedRequests(): Array<ActionPayload> {
        const savedRequests = localStorage.getItem(this.ACTION_REQUESTS_STORAGE_IDENTIFIER);

        // TODO: consider runtime type checking
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return savedRequests ? JSON.parse(savedRequests) : [];
    }

    private clearSavedRequests() {
        localStorage.removeItem(this.ACTION_REQUESTS_STORAGE_IDENTIFIER);
    }
}
